import React, { useContext } from 'react';
import { ModelTable } from '../../../../../../../../components/ModelTable/ModelTable';
import { dispatcher_dynamic_context } from '../../../../hooks/useStats_dispatcher_dynamic';
import Jelly from '../../../../../../../../components/Jelly';

const HOURS_TABLE = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
  12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
];

export let RSODynamicDispDynamicOper = () => {
  const { daylyReport, reportLength } = useContext(dispatcher_dynamic_context);

  const getLastReportedHour = (vzuItem) => {
    const dynamicHours = (vzuItem?.dynamics || [])
      .map((item) => item?.hour)
      .filter((hour) => hour !== undefined && hour !== null);

    const chlorineHours = (vzuItem?.chlorine || [])
      .map((item) => item?.hour)
      .filter((hour) => hour !== undefined && hour !== null);

    const allHours = [...dynamicHours, ...chlorineHours];

    if (allHours.length === 0) {
      return null;
    }

    return Math.max(...allHours);
  };

  const isVzuLate4Hours = (vzuItem) => {
    const lastHour = getLastReportedHour(vzuItem);

    if (lastHour === null) {
      return true;
    }

    const currentHour = new Date().getHours();
    const diff = (currentHour - lastHour + 24) % 24;

    return diff >= 4;
  };

  const getTdClass = (index) => {
    return index % 2 === 0 ? 'td-even' : 'td-odd';
  };

  const getDynamicByHour = (item, hour) => {
    return (item?.dynamics || []).find((dynamicItem) => dynamicItem?.hour === hour) || null;
  };

  const getChlorineByHour = (item, hour) => {
    return (item?.chlorine || []).find((chlorineItem) => chlorineItem?.hour === hour) || null;
  };

  return (
    <>
      {Object.keys(reportLength || {}).length !== 0 && daylyReport.length !== 0 ? (
        <div className="RSODynamicOperTable">
          <ModelTable style="oper">
            <thead>
              <tr>
                <th className="ModelTable__th-default"></th>
                {daylyReport.map((item, index) => {
                  const isLate = isVzuLate4Hours(item);

                  return (
                    <React.Fragment key={`head_group_wrap_${item.vzu_name || index}`}>
                      {reportLength?.[item.vzu_name]?.[0] ? (
                        <th
                          colSpan={reportLength?.[item.vzu_name]?.[0]}
                          className={isLate ? 'ModelTable__th-warning' : 'ModelTable__th-default'}
                        >
                          {item.vzu_name}
                        </th>
                      ) : null}
                    </React.Fragment>
                  );
                })}
              </tr>

              <tr>
                <th className="ModelTable__th-default">Час</th>
                {daylyReport.map((item, index) => (
                  <React.Fragment key={`head_cols_wrap_${item.vzu_name || index}`}>
                    {(reportLength?.[item?.vzu_name]?.[2] || []).map((item1, index1) => (
                      <th
                        key={`head_col_${item.vzu_name}_${index1}`}
                        className="ModelTable__th-default"
                      >
                        {item1}
                      </th>
                    ))}
                  </React.Fragment>
                ))}
              </tr>
            </thead>

            <tbody>
              {HOURS_TABLE.map((hour) => (
                <tr key={`hour_row_${hour}`}>
                  <td>{hour}</td>

                  {daylyReport.map((item1, index1) => {
                    const currentFields = reportLength?.[item1?.vzu_name]?.[1] || [];
                    const dynamicByHour = getDynamicByHour(item1, hour);
                    const chlorineByHour = getChlorineByHour(item1, hour);
                    const tdClass = getTdClass(index1);

                    if (currentFields.length === 0) {
                      return null;
                    }

                    return (
                      <React.Fragment key={`row_fields_${hour}_${item1.vzu_name || index1}`}>
                        {currentFields.map((fieldName, fieldIndex) => {
                          if (fieldName === 'max_chlorine') {
                            return (
                              <td
                                key={`cell_${hour}_${item1.vzu_name}_${fieldName}_${fieldIndex}`}
                                className={tdClass}
                              >
                                {chlorineByHour?.max_chlorine}
                              </td>
                            );
                          }

                          if (fieldName === 'water_level_in_reseruar') {
                            return (
                              <td
                                key={`cell_${hour}_${item1.vzu_name}_${fieldName}_${fieldIndex}`}
                                className={tdClass}
                              >
                                {dynamicByHour?.water_level_in_reseruar?.[0]}
                              </td>
                            );
                          }

                          return (
                            <td
                              key={`cell_${hour}_${item1.vzu_name}_${fieldName}_${fieldIndex}`}
                              className={tdClass}
                            >
                              {dynamicByHour?.[fieldName]}
                            </td>
                          );
                        })}
                      </React.Fragment>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </ModelTable>
        </div>
      ) : (
        <Jelly />
      )}
    </>
  );
};
